import {
  ClockCircleOutlined,
  DeleteOutlined,
  DollarOutlined,
  EditOutlined,
  EyeOutlined,
  FieldTimeOutlined,
  KeyOutlined,
  LockOutlined,
  PlusOutlined,
  SearchOutlined,
  UnlockOutlined
} from '@ant-design/icons'
import {
  Button,
  DatePicker,
  Empty,
  Form,
  Input,
  Select,
  Space,
  Tag,
  Tooltip
} from 'antd'
import dayjs from 'dayjs'
import { debounce } from 'lodash'
import get from 'lodash.get'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
  cccdRegex,
  convertPriceToNumber,
  emailRegex,
  formatCurrencyLabel,
  hasPermission,
  passportRegex,
  passwordRegex,
  phoneRegex,
  removeUndefinedValues,
  removeVietnameseTones
} from '../../config-func'
import {
  addMoney,
  changePassword,
  departmentAll,
  departmentSearch,
  permissionByDepartment,
  roleSearch,
  updateStatusUser,
  userCreate,
  userDetail,
  userSearch,
  userUpdate
} from '../../services/cmsservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import ChangePasswordModal from './ModalChangePassword'
import styles from './styles.module.scss'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { v4 as uuidv4 } from 'uuid'
import ModalAddMoney from './ModalAddMoney'
import ModalExtensionComunity from './ModalExtensionComunity'
import { pakageCommunityExtension } from '../../services/pakage-community-service'
import {
  getAllUserWeb,
  userDetailWeb,
  userWebUpdate
} from '../../services/userservice'
import Loading from '../Loading'
const { Option } = Select
export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}
const layout = {
  // labelCol: {
  //   span: 11
  // },
  wrapperCol: {
    span: 24
  }
}

const OPTIONS_ROLE = [
  {
    value: 'CEO',
    name: 'CEO'
  },
  {
    value: 'DIRECTOR',
    name: 'Giám đốc'
  },
  {
    value: 'SALE_MANAGER',
    name: 'Quản lý sản phẩm'
  },
  {
    value: 'SALE',
    name: 'Nhân viên'
  },
  {
    value: 'CUSTOMER',
    name: 'Khách hàng'
  },
  {
    value: 'COLLAB',
    name: 'Cộng tác viên'
  },
  {
    value: 'SUB_ADMIN',
    name: 'Sub Admin'
  }
]

const OPTIONS_PRODUCT_TYPE = [
  {
    value: 'ALL',
    name: 'Tất cả'
  },
  {
    value: 'SELL',
    name: 'Bán'
  },
  {
    value: 'RENT',
    name: 'Thuê'
  }
]

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const AccountManagementWeb = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [isModalOpen, setIsModalOpen] = useState(false)
  // const [pageSize, setPageSize] = useState(10) // Kích thước trang mặc định
  // const [page, setCurrentPage] = useState(1) // Trang hiện tại
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [listUser, setListUser] = useState([])
  const [listDepartment, setListDepartment] = useState([])
  const [listDepartmentAll, setListDepartmentAll] = useState([])
  const [listRole, setListRole] = useState([])
  const [visibleChangePass, setVisibleChangePass] = useState(false)
  const [visibleChangeMoney, setVisibleMoney] = useState(false)
  const [visibleExtension, setVisibleExtension] = useState(false)
  const [detailUser, setDetailUser] = useState()
  const [loading, setLoading] = useState(false)
  const userRole = Form.useWatch('user_role', form)
  const isMobile = window.innerWidth < 768
  const [departmentField, setDepartmentField] = useState({
    name: 'department',
    mode: undefined // Không multiple
  })

  const deId = localStorage.getItem('department_id')
  const userRo = localStorage.getItem('user_role')

  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10,
    reset: 0 // Số bản ghi mỗi trang
  })

  const getUserAll = async (values = {}) => {
    setLoading(true)

    try {
      const body = {
        ...values,
        page: (values.page || pagination.current || 1) - 1,
        pageSize: values.pageSize || pagination.pageSize || 10
      }

      const res = await getAllUserWeb(body)
      const list = Array.isArray(res?.list)
        ? res.list
        : Array.isArray(res?.data?.list)
          ? res.data.list
          : Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res)
              ? res
              : []
      const normalizedList = list.map((item) => ({
        ...item,
        status: item?.status ? String(item.status).toUpperCase() : item?.status
      }))
      const paging = res?.paging || res?.data?.paging
      setListUser({ data: normalizedList, paging })
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      setListUser([])
    } finally {
      setLoading(false)
    }
  }

  const getDepartment = async (id) => {
    try {
      const body = { pageSize: 1000, department_id: id }
      const res = await departmentSearch(body)
      setListDepartment(res.data)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const getDepartmentAll = async () => {
    try {
      const body = { pageSize: 1000 }
      const res = await departmentAll(body)
      setListDepartmentAll(res.data)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    if (userRo == 'ADMIN') {
      getDepartment()
    } else {
      getDepartment(deId)
    }
  }, [deId, userRo])

  useEffect(() => {
    getDepartmentAll()
  }, [])
  const handleSearch = debounce((values) => {}, 300)

  useMemo(() => {
    const value = formSearch.getFieldsValue()
    getUserAll({
      ...value,
      page: pagination.current,
      pageSize: pagination.pageSize
    })
  }, [pagination, userRo])

  const debouncedFormChange = useCallback(
    debounce(() => {
      const allValues = formSearch.getFieldsValue() // Lấy tất cả giá trị từ form
      // getUserAll({
      //   ...allValues, // Truyền toàn bộ giá trị form
      //   page: 1, // Giữ nguyên trang hiện tại
      //   pageSize: pagination.pageSize // Giữ nguyên số lượng item mỗi trang
      // })
      setPagination((prev) => ({
        ...prev,
        ...allValues,
        current: 1
      }))
    }, 300),

    [formSearch, pagination.current, pagination.pageSize]
  )

  // Form change handler with debounce
  const handleFormChange = (changedValues, allValues) => {
    debouncedFormChange(changedValues, allValues)
  }

  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại

      // Lọc ra các key có giá trị true và đưa vào mảng
      const dep = values.user_role == 'CEO' ? 'department_manage' : 'department'
      const { name, username, ...restValues } = values
      const body = {
        ...restValues,
        name: name || username,
        customerId: values.id,
        [dep]:
          values.user_role == 'CEO'
            ? values.department_manage
            : values.department
      }

      const res =
        mode == ACTION_MODE.ADD
          ? await userCreate(body)
          : await userWebUpdate(body, values.id)

      form.resetFields()
      setIsModalOpen(false)
      getUserAll()
      if (res) {
        openNotification(
          'success',
          mode == ACTION_MODE.ADD
            ? 'Thêm mới tài khoản thành công'
            : 'Cập nhật tài khoản thành công'
        )
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }
  const updateStatus = async (status, id) => {
    setLoading(true)
    try {
      const res = await updateStatusUser(status, id, 'Web')
      getUserAll()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const getDetailUser = async (id) => {
    setLoading(true)

    try {
      const res = await userDetailWeb(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setLoading(false)

        setIsModalOpen(true)
        const values = res.data

        if (values.user_role == 'CEO') {
          setDepartmentField({
            name: 'department_manage',
            mode: 'multiple'
          })
        } else {
          setDepartmentField({
            name: 'department',
            mode: ''
          })
        }
        // const p = values.user_department_info?.[0]?.department_id
        form.setFieldsValue({
          ...values,
          name: values.name || values.username,
          dateOfBirth: values.dateOfBirth
            ? dayjs(values.dateOfBirth)
            : values.dateOfBirth
          // department: values.department_id || '',
          // department_manage: values?.department_manage
          //   ?.split(',')
          //   .map((item) => Number(item.trim())),
          // productType: values.product_type,
          // permission_id: Number(values?.permission_id)
        })

        if (values.department_id) {
          getPermissionByDepartment(values.department_id)
        } else if (values.user_role == 'CUSTOMER') {
          getPermissionByDepartment('')
        }
      } else {
      }
    } catch (err) {
      setLoading(false)

      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const getPermissionByDepartment = async (id) => {
    try {
      const res = await permissionByDepartment(id)

      if (res && res.data) {
        setListRole(res.data.list) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty

        setListRole([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      setListRole([]) // Optionally, reset the list to an empty array
    }
  }

  const validateConfirmPassword = (_, value) => {
    if (!value || form.getFieldValue('password') === value) {
      return Promise.resolve()
    }
    return Promise.reject(new Error('Mật khẩu nhập lại không trùng khớp!'))
  }

  const handleChangePassword = async (values) => {
    setLoading(true)
    const body = {
      password: values.password,
      type: 'Web'
    }
    try {
      setLoading(false)

      const res = await changePassword(body, detailUser.id)
      openNotification('success', res.message)
      setVisibleChangePass(false)
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const onPaymentPackage = async (values) => {
    setLoading(true)

    const body = {
      type: 1,
      pakage_community_id: values.type,
      user_id: detailUser.id
    }
    try {
      const res = await pakageCommunityExtension(body)
      openNotification('success', res.message)
      setVisibleExtension(false)
      const value = formSearch.getFieldsValue()
      getUserAll({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
      setLoading(false)
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }
  const onAddMoney = async (values) => {
    setLoading(true)

    const body = {
      ...values,
      user_id: detailUser.id,
      amount: convertPriceToNumber(values.amount?.toString()),
      user_type: 'WEB'
    }
    try {
      const res = await addMoney(body)
      if (res.message == 'Deposit success') {
        openNotification(
          'success',
          values.type == 'ADD'
            ? 'Thêm tiền vào tài khoản thành công'
            : 'Thu hồi tiền tài khoản thành công'
        )
        setVisibleMoney(false)
        const value = formSearch.getFieldsValue()
        getUserAll({
          ...value,
          page: pagination.current,
          pageSize: pagination.pageSize
        })
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }

  const handleReset = debounce(() => {
    formSearch.resetFields()
    // getUserAll()
    setPagination((prev) => ({
      current: 1, // Nếu đổi pageSize thì reset current
      pageSize: 10,
      reset: uuidv4()
    }))
  }, 300)

  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: isMobile ? false : 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    { title: 'ID', dataIndex: 'id', key: 'id', align: 'center', width: 60 },
    { title: 'Họ tên', dataIndex: 'username', key: 'username', width: 150 },
    // {
    //   title: 'Sàn',
    //   dataIndex: 'department_id',
    //   key: 'department_id',
    //   width: 150,
    //   render: (_, record) => {
    //     if (!listDepartmentAll?.list) return null

    //     if (record.department_manage) {
    //       const departmentIds = record.department_manage
    //         ?.split(',')
    //         .map((id) => Number(id.trim()))

    //       const departmentNames = departmentIds
    //         ?.map((id) => listDepartmentAll.list.find((n) => n.id === id)?.name)
    //         ?.filter(Boolean)
    //       return (
    //         <div
    //           style={{
    //             maxWidth: 200,
    //             whiteSpace: 'pre-wrap',
    //             wordBreak: 'break-word'
    //           }}
    //         >
    //           {departmentNames?.join(',\n')}
    //         </div>
    //       )
    //     } else {
    //       return (
    //         <span>
    //           {record?.department_info?.name}
    //           {/* {listDepartmentAll.list.find((n) => n.id === record.department_id)?.name || ''} */}
    //         </span>
    //       )
    //     }
    //   }
    // },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 150
      // fixed: isMobile ? 'left' : false
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      width: 120
    },

    // {
    //   title: 'Ngày sinh',
    //   dataIndex: 'date_of_birth',
    //   key: 'date_of_birth',
    //   width: 150,
    //   render: (text) => {
    //     return <span>{text && dayjs(text).format('DD/MM/YYYY')}</span>
    //   }
    // },
    // {
    //   title: 'Số CCCD',
    //   dataIndex: 'identification_number',
    //   key: 'identification_number',
    //   width: 150
    // },
    // {
    //   title: 'TK chính',
    //   dataIndex: 'main_account',
    //   key: 'main_account',
    //   width: 150,
    //   render: (_, record) => {
    //     return (
    //       <span>
    //         {formatCurrencyLabel(record?.user_account_info?.main_account)}
    //       </span>
    //     )
    //   }
    // },
    // {
    //   title: 'TK khuyến mãi',
    //   dataIndex: 'promotion_account',
    //   key: 'promotion_account',
    //   width: 150,
    //   render: (_, record) => {
    //     return (
    //       <span>
    //         {formatCurrencyLabel(record?.user_account_info?.promotion_account)}
    //       </span>
    //     )
    //   }
    // },
    // {
    //   title: 'TK tích luỹ',
    //   dataIndex: 'total_spent_amount',
    //   key: 'total_spent_amount',
    //   width: 150,
    //   render: (_, record) => {
    //     return (
    //       <span>
    //         {formatCurrencyLabel(record?.user_account_info?.total_spent_amount)}
    //       </span>
    //     )
    //   }
    // },
    {
      title: 'Ngày đăng ký',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      render: (value) => {
        return <span>{value && dayjs(value).format('DD/MM/YYYY')}</span>
      }
    },

    // {
    //   title: 'Ngày hết hạn',
    //   dataIndex: 'date_end_communi',
    //   key: 'date_end_communi',
    //   width: 150,
    //   render: (text, record) => {
    //     return (
    //       <span>
    //         {record.user_account_info?.date_end_communi &&
    //           dayjs(record.user_account_info?.date_end_communi).format(
    //             'DD/MM/YYYY'
    //           )}
    //       </span>
    //     )
    //   }
    // },

    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'type',
      width: 150,
      render: (text) => {
        if (text === 'ACTIVE') {
          return <Tag color="green">Hoạt động</Tag>
        } else if (text === 'INACTIVE') {
          return <Tag color="red">Ngừng hoạt động</Tag>
        }
      }
    },
    {
      title: 'Hành động',
      key: 'status',
      fixed: isMobile ? false : 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {record.status !== 'delete' && (
              <>
                {hasPermission('P84.1', permissions) && (
                  <Tooltip title="Chỉnh sửa">
                    <Button
                      style={{ width: 32 }}
                      icon={<EditOutlined />}
                      onClick={() => {
                        setMode(ACTION_MODE.UPDATE)
                        getDetailUser(record.id)
                      }}
                    />
                  </Tooltip>
                )}
                {hasPermission('P84.2', permissions) && (
                  <Tooltip title="Đổi mật khẩu">
                    <Button
                      style={{ width: 32 }}
                      icon={<KeyOutlined />}
                      onClick={() => {
                        setVisibleChangePass(true)
                        setDetailUser(record)
                      }}
                    />
                  </Tooltip>
                )}
                {hasPermission('P84.3', permissions) && (
                  <Tooltip
                    title={
                      record.status == 'INACTIVE'
                        ? 'Mở khoá tài khoản'
                        : 'Khoá tài khoản'
                    }
                  >
                    <Button
                      style={{ width: 32 }}
                      icon={
                        record.status == 'INACTIVE' ? (
                          <LockOutlined style={{ color: 'red' }} />
                        ) : (
                          <UnlockOutlined style={{ color: 'green' }} />
                        )
                      }
                      // icon={<LockOutlined />}
                      onClick={() =>
                        showConfirm({
                          title: `${
                            record.status == 'ACTIVE' ? 'Khoá' : 'Mở khoá'
                          } tài khoản`,
                          content: (
                            <div>
                              Bạn có chắc chắn muốn{' '}
                              {record.status == 'ACTIVE' ? 'khoá' : 'mở khoá'}{' '}
                              tài khoản
                              <b> {record.name}</b> không?
                            </div>
                          ),
                    onOk: () =>
                            updateStatus(
                              record.status == 'INACTIVE'
                                ? 'ACTIVE'
                                : 'INACTIVE',
                              record.id
                            )
                        })
                      }
                      // onClick={() => setVisibleChangePass(true)}
                    />
                  </Tooltip>
                )}
                {hasPermission('P84.4', permissions) && (
                  <Tooltip title="Thêm tiền/Thu hồi tiền tài khoản">
                    <Button
                      style={{ width: 32 }}
                      icon={<DollarOutlined />}
                      onClick={() => {
                        setVisibleMoney(true)
                        setDetailUser(record)
                      }}
                    />
                  </Tooltip>
                )}
                {/* {hasPermission('P84.7', permissions) && (
                  <Tooltip title="Gia hạn cộng đồng">
                    <Button
                      style={{ width: 32 }}
                      icon={<ClockCircleOutlined />}
                      onClick={() => {
                        setVisibleExtension(true)
                        setDetailUser(record)
                      }}
                    />
                  </Tooltip>
                )} */}
                {hasPermission('P84.5', permissions) && (
                  <Tooltip title="Xóa tài khoản">
                    <Button
                      style={{ width: 32 }}
                      icon={<DeleteOutlined style={{ color: 'red' }} />}
                      onClick={() =>
                        showConfirm({
                          title: 'Xóa tài khoản',
                          content: (
                            <div>
                              Bạn có chắc chắn muốn xóa tài khoản
                              <b> {record.name}</b> không?
                            </div>
                          ),
                          type: 'error',
                          onOk: () => updateStatus('delete', record.id)
                          // onOk: () => deleteUser(record)
                        })
                      }
                    />
                  </Tooltip>
                )}
              </>

              // <DeleteOutlined
              //   onClick={() =>
              //     showConfirm({
              //       title: 'Xóa tài khoản',
              //       content: (
              //         <div>
              //           Bạn có chắc chắn muốn xóa tài khoản
              //           <b> {record.name}</b> không?
              //         </div>
              //       )
              //       // onOk: () => deleteUser(record)
              //     })
              //   }
              //   style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
              // />
            )}
            {/* <Button type="primary">Chi tiết</Button>
              <Button danger>Xóa</Button> */}
          </Space>
        )
      }
    }
  ]

  return (
    <div>
      <Loading loading={loading} />
      <Card className="pt-4 mb-2">
        <Form
          form={formSearch}
          // onValuesChange={handleFormChange}
          layout="vertical"
          onFinish={debouncedFormChange}
          labelCol={{ span: 24 }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              alignItems: 'center'
            }}
          >
            {/* Ô tìm kiếm */}
            {/* <Form.Item
              label="Mã nhân viên , họ tên, email, sđt"
              name="search"
              className={styles.formItem}
            >
              <Input
                prefix={<SearchOutlined />}
                placeholder="Nhập mã nhân viên, họ tên, email, số điện thoại"
                onBlur={(e) => {
                  formSearch.setFields([
                    {
                      name: 'search',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
              />
            </Form.Item> */}
            <Form.Item label="ID" name="userId" className={styles.formItem}>
              <Input
                prefix={<SearchOutlined />}
                placeholder="Nhập ID"
                onBlur={(e) => {
                  formSearch.setFields([
                    {
                      name: 'userId',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
              />
            </Form.Item>
            <Form.Item
              label="Họ tên"
              name="username"
              className={styles.formItem}
            >
              <Input
                prefix={<SearchOutlined />}
                placeholder="Nhập họ tên"
                onBlur={(e) => {
                  formSearch.setFields([
                    {
                      name: 'username',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
              />
            </Form.Item>

            <Form.Item label="Email" name="email" className={styles.formItem}>
              <Input
                prefix={<SearchOutlined />}
                placeholder="Nhập email"
                onBlur={(e) => {
                  formSearch.setFields([
                    {
                      name: 'email',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
              />
            </Form.Item>

            <Form.Item
              label="Điện thoại"
              name="phoneNumber"
              className={styles.formItem}
            >
              <Input
                prefix={<SearchOutlined />}
                placeholder="Nhập điện thoại"
                onBlur={(e) => {
                  formSearch.setFields([
                    {
                      name: 'phoneNumber',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
              />
            </Form.Item>

            {/* Dropdown Trạng thái (rộng hơn) */}
            <Form.Item
              label="Trạng thái"
              name="status"
              className={styles.formItem}
            >
              <Select
                defaultValue="Tất cả"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                <Option value="">Tất cả</Option>
                <Option value="ACTIVE">Hoạt động</Option>
                <Option value="INACTIVE">Ngừng hoạt động</Option>
              </Select>
            </Form.Item>
          </div>
          <div
            className={styles.formItem}
            style={{ textAlign: 'right', marginTop: 6 }}
          >
            <Button onClick={handleReset}>Đặt lại</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: '0 8px' }}
            >
              Tìm kiếm
            </Button>
          </div>
        </Form>
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* {hasPermission('P84.1', permissions) && (
            <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                setIsModalOpen(true)
                setMode(ACTION_MODE.ADD)
              }}
            >
              <PlusOutlined />
              Thêm mới
            </Button>
          )} */}
        </div>
        <TableField
          // loading={loading}
          columns={initialColumns}
          data={listUser?.data}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: listUser?.paging?.totalElements,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onChange: handlePageChange,
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          rowKey={(record, index) => index}
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa tài khoản'
            : 'Thêm mới tài khoản'
        }
        visible={isModalOpen}
        centered
        // width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()

          // }
          //   setFileList([])
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={mode == ACTION_MODE.ADD ? 'Thêm mới' : 'Cập nhật'}
        cancelText="Huỷ"
      >
        <Form
          // variant={'filled'}
          // labelWrap
          requiredMark={customizeRequiredMark}
          labelAlign="left"
          labelCol={{ span: 6 }}
          form={form}
          layout="horizontal"
          style={{
            // maxHeight: '80vh',
            overflow: 'auto',
            overflowX: 'hidden',
            padding: '0px 10px'
          }}
          autoComplete="off"
          inputMode="none"
          {...layout}
          // initialValues={{
          //   password: '',
          //   re_enter_password: ''
          // }}
        >
          <Form.Item name="id" label="" style={{ display: 'none' }}>
            <Input></Input>
          </Form.Item>
          <Form.Item
            name="name"
            label="Họ tên"
            rules={[
              {
                message: 'Vui lòng nhập họ tên',
                required: true
              }
            ]}
          >
            <Input
              placeholder="Nhập họ tên"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              autoComplete="off"
              inputMode="none"
            />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Vui lòng nhập email!' },
              { pattern: emailRegex, message: 'Email không hợp lệ!' }
            ]}
          >
            <Input
              placeholder="Nhập email"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'email',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              autoComplete="off"
              inputMode="none"
              disabled={mode === ACTION_MODE.UPDATE}
            />
          </Form.Item>
          <Form.Item
            label="Điện thoại"
            name="phoneNumber"
            rules={[
              { required: true, message: 'Vui lòng nhập số điện thoại!' },
              { pattern: phoneRegex, message: 'Số điện thoại không hợp lệ!' }
            ]}
          >
            <Input
              placeholder="Nhập số điện thoại"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'phoneNumber',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              autoComplete="off"
              inputMode="none"
            />
          </Form.Item>
          {/* <Form.Item
            label="Số CCCD/HC"
            name="identification_number"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập số CCCD hoặc Hộ chiếu!'
              },
              {
                pattern: new RegExp(
                  `(${cccdRegex.source})|(${passportRegex.source})`
                ),
                message:
                  'Định dạng không hợp lệ! (CCCD: 12 số, HC: 1 chữ + 7 số)'
              }
            ]}
          >
            <Input
              placeholder="Nhập số CCCD / HC"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'identification_number',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              autoComplete="off"
              inputMode="none"
            />
          </Form.Item> */}
          {/* <Form.Item
            label="Chức danh"
            name="user_role"
            rules={[
              {
                message: 'Vui lòng chọn chức danh',
                required: true
              }
            ]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn chức danh"
              onChange={() => {
                const role = form.getFieldValue('user_role')

                if (role === 'CEO') {
                  setDepartmentField({
                    name: 'department_manage',
                    mode: 'multiple'
                  })
                  form.setFieldsValue({ department_manage: null })
                } else {
                  setDepartmentField({ name: 'department', mode: undefined })
                  form.setFieldsValue({ department: null })
                }
              }}
            >
              {OPTIONS_ROLE.map((item, idx) => {
                return (
                  <Option key={idx} value={item.value}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item> */}
          {/* <Form.Item
            name={departmentField.name}
            label="Sàn"
            rules={[
              {
                message: 'Vui lòng chọn sàn',
                required: true
              }
            ]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn sàn"
              mode={departmentField.mode}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
              onChange={(value) => {
                if (value && !Array.isArray(value)) {
                  getPermissionByDepartment(value)
                  form.setFieldsValue({ permission_id: '' })
                } else {
                  // getPermissionAll() // Ví dụ khi cần reset permission list
                }
              }}
            >
              {listDepartment?.list?.map((item, idx) => {
                return (
                  <Option key={idx} value={item.id}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item> */}
          {/* {['DIRECTOR', 'SALE_MANAGER'].includes(userRole) ? (
            <Form.Item
              label="Luồng tin"
              name="product_type"
              labelCol={{ span: 6 }}
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn luồng tin'
                }
              ]}
            >
              <Select style={{ width: '100%' }} placeholder="Chọn luồng tin">
                {OPTIONS_PRODUCT_TYPE.map((item, idx) => {
                  return (
                    <Option key={idx} value={item.value}>
                      {item.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : null} */}
          {/* {userRole !== 'CEO' && (
            <Form.Item
              label="Quyền"
              name="permission_id"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn quyền'
                }
              ]}
            >
              <Select
                style={{ width: '100%' }}
                placeholder="Chọn tên quyền"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                {listRole &&
                  listRole.map((item, idx) => {
                    return (
                      <Option key={idx} value={item.id}>
                        {item.name}
                      </Option>
                    )
                  })}
              </Select>
            </Form.Item>
          )} */}

          <Form.Item
            label="Ngày sinh"
            name="dateOfBirth"
            // rules={[
            //   {
            //     required: true,
            //     message: ''
            //   }
            // ]}
          >
            <DatePicker
              placeholder="Nhập ngày sinh"
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
            />
          </Form.Item>
          {mode == ACTION_MODE.ADD && (
            <>
              <Form.Item
                label="Mật khẩu"
                name="password"
                rules={[
                  {
                    required: mode === ACTION_MODE.ADD ? true : false,
                    message: 'Vui lòng nhập mật khẩu!'
                  },
                  {
                    pattern: passwordRegex,
                    message:
                      'Mật khẩu phải có ít nhất 8 ký tự, chữ hoa, chữ thường, số và ký tự đặc biệt!'
                  }
                ]}
              >
                <Input.Password
                  placeholder="Nhập mật khẩu"
                  autoComplete="new-password"
                  inputMode="none"
                />
              </Form.Item>
              <Form.Item
                label="Nhập lại mật khẩu"
                name="re_enter_password"
                dependencies={['password']}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const password = getFieldValue('password')
                      if (mode === ACTION_MODE.ADD && password) {
                        if (!value) {
                          return Promise.reject(
                            new Error('Vui lòng nhập lại mật khẩu!')
                          )
                        }
                        if (value !== password) {
                          return Promise.reject(
                            new Error('Mật khẩu nhập lại không khớp!')
                          )
                        }
                      }
                      return Promise.resolve()
                    }
                  })
                ]}
              >
                <Input.Password
                  placeholder="Nhập lại mật khẩu"
                  autoComplete="off"
                  inputMode="none"
                />
              </Form.Item>
            </>
          )}
        </Form>
      </ModalCustom>
      <ChangePasswordModal
        visible={visibleChangePass}
        onCancel={() => setVisibleChangePass(false)}
        onChangePassword={handleChangePassword}
      />
      <ModalAddMoney
        visible={visibleChangeMoney}
        onCancel={() => setVisibleMoney(false)}
        onAddMoney={onAddMoney}
      />

      <ModalExtensionComunity
        visible={visibleExtension}
        onCancel={() => setVisibleExtension(false)}
        onFinish={onPaymentPackage}
        detailUser={detailUser}
      />
      <ModalConfirm />
    </div>
  )
}

export default AccountManagementWeb
